import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './ProjectCreationOverlay.scss';

interface ProjectCreationOverlayProps {
  visible: boolean;
  message?: string;
}

export const ProjectCreationOverlay: React.FC<ProjectCreationOverlayProps> = ({
  visible,
  message = 'Creating your project...'
}) => {
  if (!visible) return null;

  return (
    <div className="project-creation-overlay">
      <div className="overlay-content">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 32, color: '#4A3CFA' }} spin />} />
        <span className="overlay-message">{message}</span>
      </div>
    </div>
  );
};
